@file:OptIn(ExperimentalTime::class)

package com.macrofocus.high_d.axis

import com.macrofocus.common.format.CPFormat
import kotlinx.datetime.LocalDate
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.format.DateTimeFormat
import kotlinx.datetime.format.Padding
import kotlinx.datetime.format.char
import kotlinx.datetime.toLocalDateTime
import kotlin.time.ExperimentalTime
import kotlin.time.Instant

class AutoDateTimeFormat : CPFormat<Any?> {
    var dateFormat: DateTimeFormat<LocalDate> = LocalDate.Format {
        dayOfMonth(padding = Padding.NONE)  // dd
        char('.')                          // .
        monthNumber(padding = Padding.NONE) // MM
        char('.')                          // .
        year()                             // yyyy
    }
    var fullDateFormat: DateTimeFormat<LocalDateTime> = LocalDateTime.Format {
        dayOfMonth(padding = Padding.NONE)  // dd
        char('.')                          // .
        monthNumber(padding = Padding.NONE) // MM
        char('.')                          // .
        year()                             // yyyy
        char(' ')
        hour()
        char(':')
        minute()
        char(':')
        second()
    }
    override fun format(value: Any?): String? {
        return formatHtml(value, false)
    }

    override fun formatHtml(value: Any?, htmlSupported: Boolean): String? {
        return if (value != null) {
            val date: Instant
            date = if (value is Number) {
                Instant.fromEpochMilliseconds(value.toLong())
            } else if (value is Instant) {
                value
            } else {
                return value.toString()
            }
            val dateTime = date.toLocalDateTime(TimeZone.UTC)
            if (dateTime.hour != 0 || dateTime.minute != 0 || dateTime.second != 0) {
                fullDateFormat.format(dateTime)
            } else {
                dateFormat.format(dateTime.date)
            }
        } else {
            ""
        }
    }

    @Throws(CPFormat.ParsingException::class)
    override fun parse(text: String?): Any? {
        return try {
            fullDateFormat.parse(text!!)
        } catch (e: IllegalArgumentException) {
            try {
                dateFormat.parse(text!!)
            } catch (e1: IllegalArgumentException) {
                throw CPFormat.ParsingException(e.message, -1)
            }
        }
    }

    override val pattern: String?
        get() = null
    override val nativeFormat: Any?
        get() = null
    override val horizontalAlignment: CPFormat.HorizontalAlignment?
        get() = null

    override fun getClassName(value: Any?): String? {
        return null
    }
}